import { FunctionComponent, useState } from "react";

import { useTranslation } from "react-i18next";

import { faSearch } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components/Icon/Icon";
import { GlobalSearchModal } from "@/components/GlobalSearchModal/GlobalSearchModal";

/**
 * "Find a single person" hint shown in Classic search mode. Opens the global search in an
 * isolated instance so it does not mutate the sidebar's global search state.
 */
export const FindSinglePersonHint: FunctionComponent = () => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`companyEnrich.${key}`);

	const [showPersonSearch, setShowPersonSearch] = useState(false);

	return (
		<>
			<div className="flex items-center gap-2 p-3 rounded-xl border border-border-light bg-white">
				<Icon className="text-text-meta !w-[12px] h-auto" icon={faSearch} />
				<span className="text-xs text-text-meta">{ts("findSinglePersonHint")}</span>
				<button
					className="ml-auto text-xs font-semibold text-blue-action hover:underline"
					type="button"
					onClick={() => setShowPersonSearch(true)}
				>
					{ts("findSinglePersonCta")}
				</button>
			</div>

			<GlobalSearchModal isOpened={showPersonSearch} setIsOpened={setShowPersonSearch} />
		</>
	);
};
